<template>
    <div class="margin-bottom-2">
        <dl v-if="artwork.code">
          <dt>{{getTranslation('code')}}</dt>
          <dd>{{artistCode}}.{{artwork.code}}</dd>
        </dl>
        <dl v-if="artwork.year">
          <dt>{{getTranslation('year')}}</dt>
          <dd>{{artwork.year}}</dd>
        </dl>
        <dl v-if="artwork.medium">
          <dt>{{getTranslation('medium')}}</dt>
          <dd>{{artwork.medium}}</dd>
        </dl>
        <dl v-if="artwork.dimensions">
          <dt>{{getTranslation('dimensions')}}</dt>
          <dd>{{artwork.dimensions}}</dd>
        </dl>
        <dl v-if="artwork.credit">
          <dt>{{getTranslation('credit')}}</dt>
          <dd>{{artwork.credit}}</dd>
        </dl>
        <dl v-if="artwork.actor">
          <dt>{{getTranslation('actor')}}</dt>
          <dd>{{artwork.actor}}</dd>
        </dl>
        <dl v-if="artwork.sound">
          <dt>{{getTranslation('sound')}}</dt>
          <dd>{{artwork.sound}}</dd>
        </dl>
         <dl v-if="artwork.duration">
          <dt>{{getTranslation('duration')}}</dt>
          <dd>{{artwork.duration}}</dd>
        </dl>
         <dl v-if="artwork.artworks">
          <dt>{{getTranslation('artworks')}}</dt>
          <dd v-html="artwork.artworks"></dd>
        </dl>
        <dl v-if="artwork.photo">
          <dt>{{getTranslation('photo')}}</dt>
          <dd>{{artwork.photo}}</dd>
        </dl>
        <div v-for="venue in artwork.venues" :key="venue.id">
          <dl>
            <dt>{{getTranslation('location')}}</dt>
            <dd><img src="/static/icon-triangle.svg" alt="" class="nav-triangle"><router-link :to="'/99/' + venue.code">{{venue.title}}</router-link></dd>
          </dl>
          <app-map-artwork :lat="venue.latitude" :lng="venue.longitude" class="map-artwork"></app-map-artwork>
        </div>
    </div>
</template>

<script>
import mixinLanguages from '../mixins/Language'
import appMapArtwork from '../components/MapArtwork'
export default {
  name: 'metaArtwork',
  props: ['artwork','artistCode'],
  mixins: [mixinLanguages],
  components: {
    appMapArtwork: appMapArtwork,
  },
  computed: {
   
  },
  watch: {

  },
  data () {
   return {
      langCode:'',
      langYear:'',
      langMedium:'',
      langDimensions:'',
      langCredit:'',
      langActor:'',
      langSound:'',
      langDuration:'',
      langArtworks:'',
      langPhoto:'',
      langLocation:''
    }
  }
}
</script>

<style lang="scss">
  .nav-triangle {
    height:10px;
    width: auto;
    margin-right: 0.5rem; 
  }
</style>


// WEBPACK FOOTER //
// src/components/MetaArtwork.vue